// Browser autoplay policies require mute=1 for automatic playback
// The playlist parameter is crucial for single-video loops
// Combine with playsinline=1 for better mobile behavior
// For unmuted playback, users must manually click the unmute button
// loop=1
//  Enables infinite looping of the video
// autoplay=1
//  Automatically starts playback (works best with mute=1)
// mute=1
//  Required for autoplay to work in most browsers
// Custom start/end times
//  Add &start=30&end=120 to loop between specific seconds
// Disable controls
//  Add &controls=0
// Hide YouTube logo
//  Add &modestbranding=1
// Disable related videos
//  Add &rel=0

const config = {
    appName: "Clipdeo",
    apiBaseUrl: process.env.REACT_APP_API_BASE_URL,
    webSocketUrl: process.env.REACT_APP_WEBSOCKET_URL,
    facebookAppId: "670407675932526",
    videoInfoUrl: "https://www.google.com/search?q=youtube+video+",
    videoBaseUrl: "https://www.youtube.com/watch?v=",
    videoLiveUrl: "https://www.youtube.com/live/",
    videoShareUrl: "https://youtu.be/",
    videoEmbedUrl: "https://www.youtube.com/embed/video_id?autoplay=1&controls=1&loop=1&playsinline=1",
    videoMaxRes: "https://img.youtube.com/vi/video_id/maxresdefault.jpg",
    videoMinRes: "https://img.youtube.com/vi/video_id/default.jpg",
};

// console.log(config.appName);
// console.log(config.apiBaseUrl);
// console.log(config.webSocketUrl);
// console.log(config.facebookAppId);

export default config;

